export const navbar_copy = "Instaswipe";
